__turbopack_context__.v({
  "bgBluesky": "share-module__sIq2rG__bgBluesky",
  "bgFacebook": "share-module__sIq2rG__bgFacebook",
  "bgPinterest": "share-module__sIq2rG__bgPinterest",
  "bgReddit": "share-module__sIq2rG__bgReddit",
  "bgTelegram": "share-module__sIq2rG__bgTelegram",
  "bgTwitter": "share-module__sIq2rG__bgTwitter",
  "bgWhatsapp": "share-module__sIq2rG__bgWhatsapp",
  "share": "share-module__sIq2rG__share",
});
